import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { UserProfile } from 'oidc-client-ts';

const initialState: Partial<UserProfile> = {};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<Partial<UserProfile>>) => {
      return action.payload;
    },
  },
});

export const selector = (state: RootState) => state.user;
export const { setUser } = userSlice.actions;
export default userSlice.reducer;
